module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "path"
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок",
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.updateInvestmentPath(_vm.investmentPath)
      }
    },
    model: {
      value: (_vm.investmentPath.title),
      callback: function($$v) {
        _vm.$set(_vm.investmentPath, "title", $$v)
      },
      expression: "investmentPath.title"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Текст",
      "type": "textarea",
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.updateInvestmentPath(_vm.investmentPath)
      }
    },
    model: {
      value: (_vm.investmentPath.description),
      callback: function($$v) {
        _vm.$set(_vm.investmentPath, "description", $$v)
      },
      expression: "investmentPath.description"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Надпись на кнопке видео",
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.updateInvestmentPath(_vm.investmentPath)
      }
    },
    model: {
      value: (_vm.investmentPath.button_title),
      callback: function($$v) {
        _vm.$set(_vm.investmentPath, "button_title", $$v)
      },
      expression: "investmentPath.button_title"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Ссылка на видео",
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.updateInvestmentPath(_vm.investmentPath)
      }
    },
    model: {
      value: (_vm.investmentPath.button_link),
      callback: function($$v) {
        _vm.$set(_vm.investmentPath, "button_link", $$v)
      },
      expression: "investmentPath.button_link"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper",
    on: {
      "click": function($event) {
        return _vm.deleteInvestmentPath(_vm.investmentPath.id)
      }
    }
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    }
  }), _vm._v("\n    Удалить путь\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77503dee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndividualInvestment/InvestmentPath.vue
// module id = 970
// module chunks = 0